import { render, staticRenderFns } from "./ForumArticles2.vue?vue&type=template&id=2f45a12e&scoped=true&"
import script from "./ForumArticles2.vue?vue&type=script&lang=js&"
export * from "./ForumArticles2.vue?vue&type=script&lang=js&"
import style0 from "./ForumArticles2.vue?vue&type=style&index=0&id=2f45a12e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45a12e",
  null
  
)

export default component.exports